export default __webpack_public_path__ + "static/media/3.b37ae4d2.jpg";